export default {
    namespaced: true,
    state: {
        genders: [],
        userGenders: [],
        errors: {
            getGenders: {}
        }
    },
    getters: {
        gendersWithoutNull(state) {
            return state.genders.filter(item => item.id !== 0)
        }
    },
    mutations: {
        SET_GENDERS(state, payload) {
            state.genders = payload
        },
        SET_USER_GENDERS(state, payload) {
            state.userGenders = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getGenders({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getGenders',
                val: {}
            })

            const url = '/public/dict/genders'

            try {
                const resp = await this.$axios
                    .get(url, {
                        params: data
                    })
                    .then(res => {
                        return res.data
                    })

                if (data && data.existing) {
                    commit('SET_USER_GENDERS', resp)
                } else {
                    commit('SET_GENDERS', resp)
                }
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getGenders',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getGenders',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
